<template>
  <el-tree
    :check-strictly="true"
    :data="treeData"
    node-key="id"
    :highlight-current="true"
    :props="props"
    @node-click="handleClick"
    ref="dataTree"
  >
  </el-tree>

  <!-- :check-strictly="true" -->
  <!-- :load="loadNode" -->
</template>
<script>
export default {
  props: {
    treeData: {
      default: [],
      type: Array,
    },
  },
  // created(){
  //     console.log(this.treeData)
  // },
  data() {
    return {
      subjectObj: {},
      props: {
        label: "name",
        children: "children",
        isLeaf: "natureCode",
      },
    };
  },
  mounted() {},
  methods: {
    handleCheckChange(data, checked, indeterminate) {
      this.subjectObj = data;
    },
    handleClick(data, node, _slef) {
      if (node.level >= 2) {
        this.subjectObj = data;
      } else {
        this.subjectObj = null;
      }
    },
  },
};
</script>
